import React, { useState, useEffect } from 'react';
import axios from 'axios';

const CONFIG = { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } };

export const useFirebaseConfig = () => {
  const [firebaseConfig, setFirebaseConfig] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await axios.get('/api/auth/firebaseconfig', CONFIG); // API endpoint, který vrací konfiguraci
        setFirebaseConfig(response.data);
      } catch (error) {
        console.error('Error fetching Firebase config:', error);
      }
    };

    (async () => {
      await fetchConfig();
    })()
  }, []);

  return firebaseConfig;
};


export const firebaseConfig = {
  apiKey: "AIzaSyDcCY-nyk3OyWMKf7g9d0j0o7YGt26IW70",
  authDomain: "ulk-smartzos-cz.firebaseapp.com",
  databaseURL: "https://ulk-smartzos-cz-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "ulk-smartzos-cz",
  storageBucket: "ulk-smartzos-cz.appspot.com",
  messagingSenderId: "563077437810",
  appId: "1:563077437810:web:9db8e282f604818948a5eb"
};

//ULK
/*
{
  apiKey: "AIzaSyDcCY-nyk3OyWMKf7g9d0j0o7YGt26IW70",
  authDomain: "ulk-smartzos-cz.firebaseapp.com",
  databaseURL: "https://ulk-smartzos-cz-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "ulk-smartzos-cz",
  storageBucket: "ulk-smartzos-cz.appspot.com",
  messagingSenderId: "563077437810",
  appId: "1:563077437810:web:9db8e282f604818948a5eb"
};
*/


// KHK-live
/* {
  apiKey: "AIzaSyBnihuJb3-PdWg5SNKMyRxTe6U37JpbWXc",
  authDomain: "khk-smartzos-cz.firebaseapp.com",
  databaseURL: "https://khk-smartzos-cz-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "khk-smartzos-cz",
  storageBucket: "khk-smartzos-cz.appspot.com",
  messagingSenderId: "998326948549",
  appId: "1:998326948549:web:8e564edde358ec55da96ac"
}; */


// live
/* {
  apiKey: "AIzaSyCBRweoFxwqsH8BNg44rd_8mFfDVdWjZfY",
  authDomain: "live-smartzos-cz.firebaseapp.com",
  databaseURL: "https://live-smartzos-cz-default-rtdb.europe-west1.firebasedatabase.app/",
  projectId: "live-smartzos-cz",
  storageBucket: "live-smartzos-cz.appspot.com",
  messagingSenderId: "837553586747",
  appId: "1:837553586747:web:326b1d3f6521c68110921e",
  measurementId: "G-XQWD0BFXBH"
}; */

// test
/* {
  apiKey: "AIzaSyActvqUJtT7b0wi8ZYNhij0iN8TOCdPvgs",
  authDomain: "test-smartzos-cz.firebaseapp.com",
  databaseURL: "https://test-smartzos-cz-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "test-smartzos-cz",
  storageBucket: "test-smartzos-cz.appspot.com",
  messagingSenderId: "594067127721",
  appId: "1:594067127721:web:8f4c89a83d2945282b58b8",
  measurementId: "G-TCVQ8HBRZG"
}; */

// JMK live
/* {
  apiKey: "AIzaSyC1vhM6Z5xA0xUeNvzq9MEfrnBpb1rILTo",
  authDomain: "jmk-smartzos-cz.firebaseapp.com",
  databaseURL: "https://jmk-smartzos-cz-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "jmk-smartzos-cz",
  storageBucket: "jmk-smartzos-cz.appspot.com",
  messagingSenderId: "64218958421",
  appId: "1:64218958421:web:df52e7a7aaed8af62062dc"
}; */
